export default "__VITE_ASSET__81daxEr4__"